export default function (state) {
    return function (value) {
        let length = value.length >= 10;
        let pref = value.substr(0,3)
        return length && (pref === 'AUA' || pref === 'APP')
    }
}
